import DispenseRequestContainer from './dispense-attempts-container';

export default DispenseRequestContainer;
